import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  role: 'Guest',
  userId: '',
  userEmail: '',
  activeUser: '',
};

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    userInfo: (state = {}, action) => {
      return { ...state, ...action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const { userInfo } = userInfoSlice.actions;

export default userInfoSlice.reducer;
